import { render, staticRenderFns } from "./ContactConversations.vue?vue&type=template&id=3d90c36d&scoped=true&"
import script from "./ContactConversations.vue?vue&type=script&lang=js&"
export * from "./ContactConversations.vue?vue&type=script&lang=js&"
import style0 from "./ContactConversations.vue?vue&type=style&index=0&id=3d90c36d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90c36d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d90c36d')) {
      api.createRecord('3d90c36d', component.options)
    } else {
      api.reload('3d90c36d', component.options)
    }
    module.hot.accept("./ContactConversations.vue?vue&type=template&id=3d90c36d&scoped=true&", function () {
      api.rerender('3d90c36d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/ContactConversations.vue"
export default component.exports